<template>
  <div
    class="date-chip__wrapper">
    <div
      v-if="label"
      class="date-chip__label h8-text pl-4 pt-1"
      data-qa="date_label">
      {{ label }}
    </div>
    <div
      :class="['date-chip h7-text pl-3 pr-2',
               {'errored': error, 'disabled': disabled, 'readonly': readonly, 'clearable': date && clearable} ]"
      data-qa="date_chip"
      v-on="on"
      @click="ev => $emit('click', ev)">
      <div>
        <span
          v-if="!!prefix"
          class="grey--text"
          data-qa="date_chip_prefix"> {{ prefix }}</span>
        <span
          v-if="!date"
          class="pr-2 grey--text"
          data-qa="date_chip_placeholder">
          {{ placeholder || ($i18n.locale === 'en' ? '_/_/__' : '_._.__' ) }}
        </span>
        <span
          v-else
          class="pr-2"
          data-qa="date">{{ date }}</span>
      </div>

      <sButton
        v-if="date && clearable"
        class="date-chip_btn-clear"
        data-qa="btn-clear"
        icon="cross"
        small
        type="text"
        @click.stop="clear"/>
      <sIcon
        class="date-chip_icon-calendar"
        type="calendar"/>
    </div>
    <div
      v-if="error_text"
      class="h8-text pl-4 secondary__red--text"
      data-qa="date_error_text">
      {{ error_text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'dateChip',
  props: {
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    prefix: {
      type: String,
    },
    date: {
      type: String,
    },
    on: {
      type: Object,
      default: () => ({})
    },
    /**
     * статус помилки - може використовуватись без тексту, так і текст без статусу помилки
     */
    error: {
      type: Boolean,
    },
    error_text: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
  },
  methods: {
    clear() {
      this.$emit('clear')
      this.$emit('update:date', null)
    }
  }
}
</script>

<style lang="scss" scoped>
//.is-error {
//  .date-chip {
//    border: 2px solid var(--v-secondary__red-base);
//  }
//}
.sFormItem.is-error .date-chip {
  border-color: var(--color-error) !important;
}

.date-chip__wrapper {
  max-width: 175px;
}
.date-chip {
  width: 175px;

  height: 40px;
  min-height: 40px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: var(--white-color);

  border: 2px solid var(--v-main__green-base);
  border-radius: 31px;

  cursor: pointer;
  & &__label {
    white-space: nowrap;
  }
  &.errored {
    border: 2px solid var(--v-secondary__red-base);
  }
  &.disabled {
    color: gray;
    border-color: var(--main__green_locked);
    background: var(--secondary__green_locked);
  }
  &.readonly {
    border-color: var(--main__green_locked);
    background: var(--secondary__green_locked);
  }
  &_icon-calendar {
    margin-right: 5px;
  }
  &.clearable{
    .date-chip_btn-clear {
      display: none;
    }
    &:hover,
    &:focus {
      .date-chip_icon-calendar {
        display: none;
      }
      .date-chip_btn-clear {
        display: block;
      }
    }
  }
}

</style>
